import React, { PureComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getClientDeviceWidth } from '@client/redux/modules/clientDevice/selectors';
import { isSmScreen } from '@client/helpers/screens';
import { ANIMATION_WAIT } from '../constants';

import Tab from './Tab';
import styles from './Tabs.scss';

export class Tabs extends PureComponent {
    static propTypes = {
        tabs: PropTypes.array.isRequired,
        onTabClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.tabsRef = React.createRef();
        this.tabsWrapperRef = React.createRef();
    }

    render() {
        const {
            tabs,
            activeIndex,
        } = this.props;

        return (
            <div styleName="wrapper" ref={this.tabsWrapperRef}>
                <div styleName="tabs-container">
                    <ul styleName="tabs" ref={this.tabsRef}>
                        {tabs.map((tab) => {
                            const tabIndex = tabs.indexOf(tab);

                            return (
                                <Tab
                                    key={tab.id}
                                    name={this.normalizeTabName(tab.name)}
                                    index={tabIndex}
                                    active={tabIndex === activeIndex}
                                    onAction={this.changeTab}
                                />
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }

    componentDidMount = () => {
        this.updateTabsPosition();
    }
    componentDidUpdate = (prevProps) => {
        const { activeIndex } = this.props;

        if (prevProps.activeIndex !== activeIndex) {
            this.updateTabsPosition();

        }
    }

    normalizeTabName = (name) => {
        if (typeof name !== 'string') {
            return '';
        }

        return name.toLowerCase().split(' ').map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }

    changeTab = (tabIndex) => {
        const { onTabClick, deviceWidth } = this.props;
        const timeout = isSmScreen(deviceWidth) ? ANIMATION_WAIT : 0;
        onTabClick(tabIndex, timeout);
    }

    updateTabsPosition = () => {
        const { activeIndex, deviceWidth } = this.props;
        const tabsElem = this.tabsRef.current;

        if (!tabsElem) {
            return;
        }

        if (!isSmScreen(deviceWidth)) {
            tabsElem.parentElement.scrollLeft = 0;

            return;
        }

        const { width: containerWidth } = this.tabsWrapperRef.current.getBoundingClientRect();
        const children = Array.from(tabsElem.childNodes);
        const { x, width } = children[activeIndex].getBoundingClientRect();

        const difference = ((containerWidth * 0.5) - (width * 0.5)) - x;
        tabsElem.parentElement.scrollLeft = tabsElem.parentElement.scrollLeft - difference;
    }
}

const mapStateToProps = (state) => ({
    deviceWidth: getClientDeviceWidth(state)
});

export default connect(
    mapStateToProps,
    {}
)(CSSModules(Tabs, styles, { allowMultiple: true }));
